import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { TaskStatusType } from '@/app/enums/TaskStatusType';
import { TaskType } from '@/app/enums/TaskType';
import { type ExportRequestDto } from '@/app/models/ExportRequestDto';
import { addStartedTask } from '../../task';
import { fetchExportColumns, startExport } from './_requests';
import { DEFAULT_EXPORT_TITLE } from './_utils';

/** Catálogo de colunas do exportador; o modal mostra o próprio erro em vez de derrubar a tela. */
export const useExportColumns = (exportEndpoint: string | undefined, enabled: boolean) =>
  useQuery({
    queryKey: ['exportColumns', exportEndpoint],
    queryFn: () => fetchExportColumns(exportEndpoint!),
    enabled: enabled && !!exportEndpoint,
    staleTime: Infinity,
    meta: { suppressGlobalError: true },
  });

/** Inicia a exportação pelo backend e devolve o nome da tarefa; quem espera observa o cache de tarefas. */
export const useStartExport = (exportEndpoint: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ExportRequestDto) => startExport(exportEndpoint!, request),
    onSuccess: (name) =>
      addStartedTask(queryClient, {
        name,
        type: TaskType.EXPORT,
        // Como no backend: a tarefa nasce "Exportação" e ganha o título do documento depois da consulta.
        title: DEFAULT_EXPORT_TITLE,
        status: TaskStatusType.RUNNING,
        progress: 0,
        start_time: new Date().toISOString(),
      }),
  });
};
